import { HelmetDexteel } from "@dexteel/mesf-core";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@mui/material";

export interface ConfirmationDialogRawProps {
	title: string;
	message?: string;
	open: boolean;
	onClose: (value?: string) => void;
	buttons?: {
		no: string;
		yes: string;
	};
	suffixTitle?: string;
}
export const ConfirmationDialogRaw = ({
	title,
	message,
	open,
	onClose,
	suffixTitle,
	buttons = { no: "Cancel", yes: "Ok" },
	...other
}: ConfirmationDialogRawProps) => {
	const handleCancel = () => {
		onClose("Cancel");
	};
	const handleOk = () => {
		onClose("OK");
	};
	return (
		<>
			{open && (
				<HelmetDexteel
					title={`${title}${suffixTitle ? ` - ${suffixTitle}` : ""}`}
				/>
			)}
			<Dialog maxWidth="xs" open={open} {...other}>
				<DialogTitle>{title}</DialogTitle>
				<DialogContent dividers>
					<DialogContentText>{message}</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						autoFocus
						onClick={handleCancel}
						data-test-id="cancel-dialog-button"
					>
						{buttons.no}
					</Button>
					<Button onClick={handleOk} data-test-id="confirm-dialog-button">
						{buttons.yes}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};
